import { useRoot } from './RootProvider';

export function useStructures() {
  return useRoot().structures;
}
